import { render } from "./DealWithDetail.vue?vue&type=template&id=372fe9e9&scoped=true&ts=true&lang=pug"
import script from "./DealWithDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./DealWithDetail.vue?vue&type=script&lang=ts&setup=true"

import "./DealWithDetail.vue?vue&type=style&index=0&id=372fe9e9&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372fe9e9"]])

export default __exports__